import { render, staticRenderFns } from "./v-overlay-loading.vue?vue&type=template&id=59a24e28&scoped=true"
import script from "./v-overlay-loading.vue?vue&type=script&lang=js"
export * from "./v-overlay-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a24e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VOverlay,VProgressLinear})
